import Slider from './components/slider';

const images = document.getElementsByClassName('js-img');
if (images.length > 0) {
  new Slider(images);
}

const reviews = document.getElementsByClassName('js-review');
if (reviews.length > 0) {
  new Slider(reviews);
}

const anchors = document.querySelectorAll('.js-anchor');

if (anchors) {
  [...anchors].forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(item.hash);
      const y = target.getBoundingClientRect().top + window.pageYOffset - 130;
      window.scrollTo({top: y, behavior: 'smooth'});
    })
  })
}
